import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Tour configuration for the parts page
// Highlights key features: timeline/vine, part interactions, and filters

export const partsTourConfig: TourConfig = {
    id: "parts-tour",
    page: "/parts",

    welcome: {
        title: "A Home for Your Parts",
        description: "Take a brief tour of the Parts feature",
        startButtonText: "Take Tour",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "vine-timeline",
            targetSelector: "[data-tour-id='parts-timeline']",
            title: "Your Parts Timeline",
            content:
                "Your parts are shown here in order of most-recent appearance in your session(s).",
            position: "right",
        },
        {
            id: "part-card-interactions",
            targetSelector: "[data-tour-id='first-part-card']",
            title: "Manage Your Parts",
            content:
                "Hover your mouse over any part to reveal options: pin it to keep it front-and-center, or check the box on two or more parts to link duplicates together.",
            position: "bottom",
        },
        {
            id: "filters",
            targetSelector: "[data-tour-id='parts-filters']",
            title: "Filter Your Parts",
            content:
                "By default, parts you briefly mentioned are hidden. Use the filters to display more or fewer parts.",
            position: "bottom",
            highlightState: "expanded",
        },
    ],
};
